import axios from 'axios';
import { baseURL } from '../Constants';
import { RoleSummaryDto } from '../models/PlayerRole';

const url = `${baseURL}/PlayerRole`;

export const getPlayerRoleSummary = async (
    steamId: string,
    season?: number
): Promise<RoleSummaryDto[]> => {
    try {
        const params = new URLSearchParams();
        if (season) params.append('season', season.toString());
        const queryString = params.toString();
        const response = await axios.get(
            `${url}/player/${steamId}${queryString ? `?${queryString}` : ''}`
        );
        return response.data;
    } catch (error: any) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error('Error fetching player role summary:', error);
        return [];
    }
};

export const getPlayerMapRoles = async (
    steamId: string,
    season?: number
): Promise<RoleSummaryDto[]> => {
    try {
        const params = new URLSearchParams();
        if (season) params.append('season', season.toString());
        const queryString = params.toString();
        const response = await axios.get(
            `${url}/player/${steamId}/map-roles${queryString ? `?${queryString}` : ''}`
        );
        return response.data;
    } catch (error: any) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error('Error fetching player map roles:', error);
        return [];
    }
};
